export {};

if (!customElements.get('quantity-popover')) {
  customElements.define(
    'quantity-popover',
    class QuantityPopover extends HTMLElement {
      mql: MediaQueryList;
      mqlTablet: MediaQueryList;
      infoButtonDesktop: HTMLButtonElement | null;
      infoButtonMobile: HTMLButtonElement | null;
      popoverInfo: HTMLElement | null;
      closeButton: HTMLButtonElement | null;
      eventMouseEnterHappened: boolean = false;

      constructor() {
        super();
        this.mql = window.matchMedia('(min-width: 990px)');
        this.mqlTablet = window.matchMedia('(min-width: 750px)');
        this.infoButtonDesktop = this.querySelector('.quantity-popover__info-button--icon-only');
        this.infoButtonMobile = this.querySelector('.quantity-popover__info-button--icon-with-label');
        this.popoverInfo = this.querySelector('.quantity-popover__info');
        this.closeButton = this.querySelector('.button-close');

        this.closeButton?.addEventListener('click', (e) => this.handleClosePopover(e));

        if (this.popoverInfo && this.infoButtonDesktop && this.mqlTablet.matches) {
          this.popoverInfo.addEventListener('mouseleave', (e) => this.handleClosePopover(e));
        }

        if (this.infoButtonDesktop) {
          this.infoButtonDesktop.addEventListener('click', (e) => this.handleTogglePopover(e));
          this.infoButtonDesktop.addEventListener('focusout', (e) => this.handleClosePopover(e));
        }

        this.infoButtonMobile?.addEventListener('click', (e) => this.handleTogglePopover(e));

        if (this.infoButtonDesktop && this.mqlTablet.matches) {
          this.infoButtonDesktop.addEventListener('mouseenter', (e) => this.handleTogglePopover(e));
          this.infoButtonDesktop.addEventListener('mouseleave', (e) => this.handleClosePopover(e));
        }
      }

      handleTogglePopover(event: Event): void {
        event.preventDefault();
        if (event.type === 'mouseenter') this.eventMouseEnterHappened = true;
        if (event.type === 'click' && this.eventMouseEnterHappened) return;

        const button =
          this.infoButtonDesktop && this.mql.matches ? this.infoButtonDesktop : this.infoButtonMobile;
        if (!button || !this.popoverInfo) return;

        const isExpanded = button.getAttribute('aria-expanded') === 'true';

        if ((this.mql.matches && !isExpanded) || event.type === 'click') {
          button.setAttribute('aria-expanded', String(!isExpanded));
          this.popoverInfo.toggleAttribute('hidden');
          button.classList.toggle('quantity-popover__info-button--open');
          this.infoButtonDesktop?.classList.add('quantity-popover__info-button--icon-only--animation');
        }

        const isOpen = button.getAttribute('aria-expanded') === 'true';
        if (isOpen && event.type !== 'mouseenter') {
          button.focus();
          button.addEventListener('keyup', (e: KeyboardEvent) => {
            if (e.key === 'Escape') this.handleClosePopover(e);
          }, { once: true });
        }
      }

      handleClosePopover(event: Event): void {
        event.preventDefault();
        if (!this.infoButtonDesktop || !this.popoverInfo) return;

        const relatedTarget = (event as FocusEvent).relatedTarget as Node | null;
        const isButtonChild = this.infoButtonDesktop.contains(relatedTarget);
        const isPopoverChild = this.popoverInfo.contains(relatedTarget);
        const button =
          this.infoButtonDesktop && this.mql.matches ? this.infoButtonDesktop : this.infoButtonMobile;

        if (!isButtonChild && !isPopoverChild) {
          button?.setAttribute('aria-expanded', 'false');
          button?.classList.remove('quantity-popover__info-button--open');
          this.popoverInfo.setAttribute('hidden', '');
          this.infoButtonDesktop.classList.remove('quantity-popover__info-button--icon-only--animation');
        }

        this.eventMouseEnterHappened = false;
      }
    }
  );
}
